import React from 'react';
import { Dimensions } from 'react-native';
import Modal from 'react-native-modal';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import VFLottieView, { LottieTypes } from '../VFLottieView';

import styles from './SpinnerOverlay.styles';

const screenHeight = Dimensions.get('window').height;

const SpinnerOverlay = ({
  source,
  loop,
  autoPlay,
  lottieStyle,
  isVisible,
  type,
  ...modalProps
}) => {
  return (
    <Modal
      isVisible={isVisible}
      backdropTransitionOutTiming={0} // fix bug of screen flicker on close modal
      statusBarTranslucent
      deviceHeight={screenHeight}
      useNativeDriver
      {...modalProps}
      testID={FoundationTestKeys.spinnerOverlayModal}
    >
      <VFLottieView
        type={type}
        autoPlay={autoPlay}
        loop={loop}
        lottieViewStyle={[styles.lottieContainer, lottieStyle]}
        testID={FoundationTestKeys.spinnerTestId}
      />
    </Modal>
  );
};
SpinnerOverlay.propTypes = {
  source: PropTypes.object,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  lottieStyle: PropTypes.object,
  isVisible: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(LottieTypes)),
};
SpinnerOverlay.defaultProps = {
  type: LottieTypes.whiteSpinner,
  lottieStyle: {},
};
export default SpinnerOverlay;
